(function () {
  var g = window.advGeo;
  if (!g) return;
  var tokens = {
    '{country}': g.countryName,
    '{currency}': g.currencySymbol,
    '{currencyCode}': g.currencyCode,
    '{nationality}': g.nationality
  };
  var keys = Object.keys(tokens);
  if (!keys.length) return;
  var pattern = new RegExp(keys.map(function (k) {
    return k.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  }).join('|'), 'g');

  function swap(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      if (!node.nodeValue || node.nodeValue.indexOf('{') === -1) return;
      var replaced = node.nodeValue.replace(pattern, function (m) {
        return tokens[m] != null ? tokens[m] : m;
      });
      if (replaced !== node.nodeValue) node.nodeValue = replaced;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { swap(document.body); });
  } else {
    swap(document.body);
  }
})();
